import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  async fetchChargeRateList(data) {
    let response = await apiCall("rate/list", data);
    return response;
  },

  async createChargeRate(data) {
    let response = await apiCall("rate/add", data);
    return response;
  },

  async updateChargeRate(data) {
    let response = await apiCall("rate/update", data);
    return response;
  },

  async fetchSchoolRateList(data) {
    let response = await apiCall("school_rate/list", data);
    return response;
  },

  async createSchoolRate(data) {
    let response = await apiCall("school_rate/add", data);
    return response;
  },

  async updateSchoolRate(data) {
    let response = await apiCall("school_rate/update", data);
    return response;
  },

  async deleteSchoolRate(data) {
    let response = await apiCall("school_rate/delete", data);
    return response;
  },
  async createChargeType(data) {
    let response = await apiCall("type/add", data);
    return response;
  },
  async fetchChargeTypeList(data) {
    let response = await apiCall("type/list", data);
    return response;
  },

  async fetchGlobalPocketMoneySettings() {
    let data = {
      type: "global"
    };
    let response = await apiCall("pocket_money/setting/list", data);
    return response;
  },

  async fetchSchoolPocketMoneySettings() {
    let data = {
      type: "school"
    };
    let response = await apiCall("pocket_money/setting/list", data);
    return response;
  },

  async fetchVendorPocketMoneySettings() {
    let data = {
      type: "vendor"
    };
    let response = await apiCall("pocket_money/setting/list", data);
    return response;
  },
  async createSetting(function_name, vendor_id, school_id) {
    let data = {
      function_name: function_name,
      vendor_id: vendor_id,
      school_id: school_id
    };
    let response = await apiCall("pocket_money/setting/add", data);
    return response;
  },
async enableTransactions(id) {
    let data = {
      id: id
    };
    let response = await apiCall("pocket_money/setting/enable", data);
    return response;
  },
  async disableTransactions(id) {
    let data = {
      id: id
    };
    let response = await apiCall("pocket_money/setting/disable", data);
    return response;
  },

  async fetchCanteenDepositRates(data) {
    let response = await apiCall("mobile/webapp/deposit_rates/canteen/list", data);
    return response;
  },

  async updateCanteenDepositRate(data) {
    let response = await apiCall("mobile/webapp/update_canteen_deposit_rates", data);
    return response;
  },

  async createCommisssionPercentage(data) {
    let response = await apiCall("commission_percentage/add", data);
    return response;
  },

  async fetchCommissionPercentages(data) {
    let response = await apiCall("commission_percentage/list", data);
    return response;
  },

  async updateCommissionPercentage(data) {
    let response = await apiCall("commission_percentage/update", data);
    return response;
  },

}